/** Essay prize paths on the marketing site (for NavBar / Footer links). */
export const ESSAY_PRIZE_NAV_ITEMS: { label: string; path: string }[] = [
  { label: "Overview", path: "/national-essay-prizes" },
  {
    label: "Undergraduate & Foundation",
    path: "/national-essay-prizes/undergraduate-foundation",
  },
  {
    label: "Trainees & Fellows",
    path: "/national-essay-prizes/trainees-fellows",
  },
];
